// Helper per creare i metadati di paginazione
export const createPaginationMeta = (items, itemsPerPage = 15) => {
    if (!items || items.length === 0) {
        return {
            chunks: [],
            totalPages: 0,
            totalItems: 0,
            needsPagination: false
        };
    }

    const totalItems = items.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const needsPagination = totalItems > itemsPerPage;

    // Crea array di chunks con gli ID degli elementi
    const chunks = [];
    for (let i = 0; i < totalItems; i += itemsPerPage) {
        const chunkItems = items.slice(i, i + itemsPerPage);
        chunks.push({
            pageNumber: Math.floor(i / itemsPerPage) + 1,
            startIndex: i,
            endIndex: Math.min(i + itemsPerPage - 1, totalItems - 1),
            itemIds: chunkItems.map(item => item.id), // Uso l'UUID del backend
            items: chunkItems // salvo direttamente gli oggetti
        });
    }

    return {
        chunks,
        totalPages,
        totalItems,
        itemsPerPage,
        needsPagination
    };
};